import * as React from 'react';
import { useMemo } from 'react';
import { AppFormView } from '../AppEditForm/view';
import { AppFragment, useAppCreate } from '../../../types/generated';
import { useNavigate } from 'react-router-dom';

export type AppFragmentCreate = Pick<
    AppFragment,
    | 'name'
    | 'type'
    | 'status'
    | 'linkedVendor'
    | 'appUrl'
    | 'redirectUrlWhitelist'
    | 'apiContactEmail'
    | 'installationCountries'
    | 'chargeType'
    | 'oneTimeChargeAmount'
    | 'freeTrialDays'
    | 'id'
>;
export function AppCreateForm() {
    const LIST = '/extranet/apps';
    const navigate = useNavigate();
    const selectedApp = useMemo<AppFragmentCreate>(
        () => ({
            name: '',
            type: 'PUBLIC',
            status: 'DRAFT',
            linkedVendor: null,
            appUrl: '',
            redirectUrlWhitelist: '',
            apiContactEmail: '',
            installationCountries: [],
            chargeType: 'FREE_TO_INSTALL',
            oneTimeChargeAmount: 0,
            freeTrialDays: 0,
            id: null,
        }),
        []
    );

    const [appCreate, { loading }] = useAppCreate({
        onCompleted: data => {
            if (data) {
                navigate('/extranet/apps/' + data.appCreate.node.id + '/dashboard');
            }
        },
    });

    const onSubmit = (values, form, callback) => {
        appCreate({ variables: values })
            .then(() => {
                callback();
            })
            .catch(err => callback(err));
    };

    const onCancel = () => {
        navigate(LIST);
    };

    return (
        <AppFormView app={selectedApp} loading={loading} onCancel={onCancel} onSubmit={onSubmit} />
    );
}
